module.exports = __webpack_public_path__ + "static/media/loader-switch-flight-filters.1b508269.gif";